export type MadhhabId = "hanafi" | "shafii" | "maliki" | "hanbali";

export interface Madhhab {
  id: MadhhabId;
  name: { en: string; bn: string };
  /** Hanafi combines gold + silver + cash and compares against silver Nisab. */
  combineAssetsForNisab: boolean;
  /** Preferred / default Nisab basis for this school. */
  preferredNisab: "silver" | "gold";
  notes: { en: string; bn: string };
}

export const MADHHABS: Madhhab[] = [
  {
    id: "hanafi",
    name: { en: "Hanafi", bn: "হানাফী" },
    combineAssetsForNisab: true,
    preferredNisab: "silver",
    notes: {
      en: "Default in Bangladesh. Combines all wealth (gold + silver + cash) and compares to silver Nisab. Inventory valued at market price. Only the immediately due installment of long-term debt is deductible.",
      bn: "বাংলাদেশের প্রধান মাযহাব। সকল সম্পদ (সোনা + রুপা + নগদ) একত্র করে রুপার নিসাবের সাথে তুলনা করা হয়। ব্যবসার পণ্য বাজারমূল্যে ধরা হয়। দীর্ঘমেয়াদি ঋণের শুধু পরিশোধ্য কিস্তি বিয়োগযোগ্য।",
    },
  },
  {
    id: "shafii",
    name: { en: "Shafi'i", bn: "শাফি'ঈ" },
    combineAssetsForNisab: false,
    preferredNisab: "gold",
    notes: {
      en: "Each asset class (gold, silver, cash) is checked against its own Nisab independently. Tends to use gold Nisab for cash equivalents.",
      bn: "প্রতিটি সম্পদ শ্রেণি (সোনা, রুপা, নগদ) আলাদাভাবে নিজস্ব নিসাবের সাথে তুলনা করা হয়। নগদের জন্য সাধারণত সোনার নিসাব ব্যবহৃত হয়।",
    },
  },
  {
    id: "maliki",
    name: { en: "Maliki", bn: "মালিকী" },
    combineAssetsForNisab: true,
    preferredNisab: "gold",
    notes: {
      en: "Combines monetary assets. Stricter on debt deduction — only debts that would reduce wealth below Nisab are considered.",
      bn: "নগদ সম্পদ একত্র করা হয়। ঋণ বিয়োগে কঠোর — শুধু সেই ঋণই বিয়োগযোগ্য যা সম্পদকে নিসাবের নিচে নামিয়ে আনে।",
    },
  },
  {
    id: "hanbali",
    name: { en: "Hanbali", bn: "হাম্বলী" },
    combineAssetsForNisab: true,
    preferredNisab: "gold",
    notes: {
      en: "Similar to Hanafi in combining assets but typically uses gold Nisab as the primary threshold.",
      bn: "সম্পদ একত্রকরণে হানাফীর মতো, তবে সাধারণত সোনার নিসাবকে মূল মানদণ্ড ধরা হয়।",
    },
  },
];

export function getMadhhab(id: MadhhabId): Madhhab {
  return MADHHABS.find((m) => m.id === id) ?? MADHHABS[0];
}
